<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'lineChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        }
        // colorArr:{
        //     type: Array | Object,
        //     default: function () {
        //         let colr = 
        //         return colr;
        //     }
        // }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        barOption(){
            let _this = this;
            var xWidth = (_this.xAxisName=='')?'10':'50';
            var option = {
                tooltip: {
                    trigger: 'item',
                    triggerOn: 'mousemove'
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '下载',
                        }
                    }
                },
                series: [
                    {
                        type: 'tree',

                        data: [_this.dataArray],

                        top: '1%',
                        left: '7%',
                        bottom: '1%',
                        right: '20%',

                        symbolSize: 7,

                        label: {
                            normal: {
                                position: 'left',
                                verticalAlign: 'middle',
                                align: 'right',
                                fontSize: 12
                            }
                        },

                        leaves: {
                            label: {
                                normal: {
                                    position: 'right',
                                    verticalAlign: 'middle',
                                    align: 'left'
                                }
                            }
                        },

                        expandAndCollapse: true,
                        animationDuration: 550,
                        animationDurationUpdate: 750
                    }
                ]
            };
            return option;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.barOption());
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/echart/treeChart.vue